export default {
  ALGOLIA_APP_ID,
  ALGOLIA_API_KEY,
  ENABLE_BADGES,
  SEARCH_DEBOUNCE_TIME: 400,
};
